import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { CommonButton, CustomLeftIcon } from "../../../common/StyledComponents/StyledFields";
import { useEffect, useRef, useState } from "react";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { ClipLoader } from "react-spinners";
import styles from "../../../devoteeService/devoteeService.module.scss"
import { apiRequest } from "../../../../infrastructure/backendService";
import { CMS_BASE_URL } from "../../../../config/apiUrl";

export const hiddenElements = {
   items:{
    display:"none"
   }
  };

const EventsHtmlContent = () => {
    const [loading, setLoading] = useState(false)
    const [loaderPrint, setLoaderPrint] = useState(false);
    const location = useLocation();
    console.log(location, "location");
    const navigate = useNavigate();
    const [HTMLPage, setHTMLPage] = useState<any>(null);
    const [searchParam] = useSearchParams();
    const eventType = searchParam.get("eventType")
    const eventName = searchParam.get("eventName")
    const eventTypeLower = eventType ? eventType.toLowerCase() : "";
    const eventNameLower = eventName ? eventName.toLowerCase() : "";

    useEffect(() => {
      apiRequest({
          basePath: `${CMS_BASE_URL}`,
          method: "GET",
          endpoint: eventType === "specialEvents" ? "/wp-json/wp/v2/specialevents?per_page=100" : "/wp-json/wp/v2/upcomingevents?per_page=100",
      })
          .then((res) => {
              const event = res.data.find((event: any) => event.acf.event_title === eventName);
              setHTMLPage(event?.acf?.html_page);
          })
          .catch((err) => {
              console.log(err);
          });
  }, [])

    const handlebackClick = () => {
        navigate('/')
    }
    useEffect(() => {
        window.scroll(0, 200)
    }, [])
    
    const pdfRef = useRef<any>();

    const handlePrintClick = () => {
        setLoaderPrint(true);
        const input = pdfRef.current;
    
        if (!input) {
          console.error("pdfRef is not assigned to an HTML element");
          return;
        } else {
          html2canvas(input).then((canvas) => {
            const imgData = canvas.toDataURL("image/png");
            const pdf = new jsPDF("p", "mm", "a4", true);
            const pdfWidth = pdf.internal.pageSize.getWidth();
            const pdfHeight = pdf.internal.pageSize.getHeight();
            const imgWidth = canvas.width;
            const imgHeight = canvas.height;
            const ratio = Math.min(pdfWidth / imgWidth, pdfHeight / imgHeight);
            const imgX = (pdfWidth - imgWidth * ratio) / 2;
            const imgY = 0;
            pdf.addImage(
              imgData,
              "PNG",
              imgX,
              imgY,
              imgWidth * ratio,
              imgHeight * ratio
            );
    
            // Open a new window with the PDF preview
            const newWindow = window.open("", "_blank");
            newWindow?.document.write(
              "<html><head><title>PDF Preview</title></head><body>"
            );
            newWindow?.document.write(
              '<iframe  width="100%" height=100%" src="' +
                pdf.output("datauristring") +
                '"></iframe>'
            );
            newWindow?.document.write("</body></html>");
            setLoaderPrint(false);
          });
        }
    
   
      };
    

    const downloadPDF = () => {
        setLoading(true);
        const input = pdfRef.current;
      
        if (!input) {
            setLoading(false);
          console.error("pdfRef is not assigned to an HTML element");
          return;
        }
      
        // Scroll to the top of the content before capturing
        input.scrollTo(0, 0);
      
        void html2canvas(input, { scrollY: -window.scrollY }).then((canvas) => {
          const imgData = canvas.toDataURL("image/png");
          const pdf = new jsPDF("p", "mm", "a4", true);
          const pdfWidth = pdf.internal.pageSize.getWidth();
          const pdfHeight = pdf.internal.pageSize.getHeight();
          const imgWidth = canvas.width;
          const imgHeight = canvas.height;
          const ratio = Math.min(pdfWidth / imgWidth, pdfHeight / imgHeight);
          const imgX = (pdfWidth - imgWidth * ratio) / 2;
          const imgY = 0; // Adjust as needed to add margin at the top
          pdf.addImage(imgData, "PNG", imgX, imgY, imgWidth * ratio, imgHeight * ratio);
          pdf.save(`${eventTypeLower}-${eventNameLower}.pdf`);
          setLoading(false);
        });
      };
      
    return (
      <div>
        <div onClick={handlebackClick} style={{ marginLeft: "20px" }}>
          <CustomLeftIcon />
        </div>
        <div
          style={{
            display: "flex",
            gap: "1rem",
            float: "right",
            marginTop: "-30px",
          }}
          className={styles.printHidden}
        >
          <CommonButton onClick={handlePrintClick} disabled={loaderPrint}>
            {loaderPrint ? (
              <>
                <ClipLoader color="#fff" loading={loaderPrint} size={15} />
                <span
                  style={{
                    marginLeft: "8px",
                    fontSize: "15px",
                    textAlign: "center",
                  }}
                >
                  Printing...
                </span>
              </>
            ) : (
              "Print"
            )}
          </CommonButton>
          <CommonButton onClick={downloadPDF} disabled={loading}>
            {loading ? (
              <>
                <ClipLoader color="#fff" loading={loading} size={15} />
                <span
                  style={{
                    marginLeft: "8px",
                    fontSize: "15px",
                    textAlign: "center",
                  }}
                >
                  Downloading...
                </span>
              </>
            ) : (
              "Download"
            )}
          </CommonButton>
        </div>

        <div
          ref={pdfRef}
          dangerouslySetInnerHTML={{ __html: HTMLPage }}
        />

        {/* <iframe src={location.state.key} width="1000" height="800"></iframe> */}
      </div>
    );
};

export default EventsHtmlContent;
